import { Request } from '../request';
import { IBasicInfoStep, ILicense, IProfessionalProfile, IBackgroundInfo } from 'types/newUniprofile';
import { Physician } from 'types/common';
import { IInsurance } from 'types/insurance';

export const getBasicInfo = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/uniprofile/basic/info/detail', scheduleToken });

export const getLicense = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/uniprofile/license/list', scheduleToken });

export const getInsurance = () => Request.get({ url: '/schedule-server/provider/uniprofile/insurance/detail' });

export const getProfessionalProfile = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/uniprofile/professional/detail', scheduleToken });

export const getBackground = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/uniprofile/background/detail', scheduleToken });

export const editBasicInfo = (data: IBasicInfoStep, scheduleToken?: string) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/basic/info/save', params: data, scheduleToken });

export const editIdentification = (data: ILicense) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/license/save/batch', params: data });

export const editInsurance = (data: IInsurance) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/insurance/save', params: data });

export const editProfessionalProfile = (data: IProfessionalProfile, scheduleToken?: string) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/professional/save', params: data, scheduleToken });

export const editBackground = (data: IBackgroundInfo, scheduleToken?: string) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/background/save', params: data, scheduleToken });

export const editCollaboratingPhysician = (data: Physician[], scheduleToken?: string) =>
    Request.post({ url: '/schedule-server/physician/update/batch', params: data, scheduleToken });

export const getAIAiAboutMe = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/ai/aboutMe', scheduleToken });
